import { motion } from "framer-motion";
import { ArrowUpLeft } from "lucide-react";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.14 } } };
const line = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } }
};

export const ArabicCreed = ({ onNavigate }) => (
  <section data-testid="arabic-creed" dir="rtl" lang="ar" className="bg-green py-28 md:py-36 relative overflow-hidden grain">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
      <motion.p
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-gold text-[11px] tracking-mega uppercase mb-10" style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
        لزوّارنا من المملكة العربية السعودية
      </motion.p>
      <motion.h2
        variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }}
        className="font-display text-[9vw] sm:text-5xl lg:text-7xl leading-[1.3] text-cream max-w-5xl">
        <span className="mask-line pb-2"><motion.span variants={line} className="block">نبني الفكرة،</motion.span></span>
        <span className="mask-line pb-2"><motion.span variants={line} className="block text-gold">ونبيع الفكرة.</motion.span></span>
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        transition={{ delay: 0.35, duration: 0.8, ease: "easeOut" }}
        className="mt-10 text-cream/65 text-sm md:text-base leading-loose max-w-xl">
        مكتبة حيّة من أنظمة الذكاء الاصطناعي الجاهزة للبناء — نموذج أوّلي يعمل خلال ٢١ يومًا،
        إثبات على أعمال حقيقية، ثم تسليم كامل. للشركات وللأفراد على حدّ سواء.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}>
        <button data-testid="arabic-cta" onClick={() => onNavigate("contact")}
          className="group mt-10 inline-flex items-center gap-3 bg-gold text-ink text-sm px-8 py-4 hover:bg-cream transition-colors duration-300">
          ناقش فكرتك معنا
          <ArrowUpLeft size={15} className="transition-transform duration-300 group-hover:-translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </motion.div>
    </div>
    <span aria-hidden="true" className="absolute -left-10 -bottom-24 font-display text-[22rem] leading-none text-cream/[0.04] select-none pointer-events-none">ع</span>
  </section>
);
